<template>
  <div class="wrap adminPage">
     <template v-if="!loading">
       <template v-if="user">
         <AdminMenu/>
         <div class="page-wrap">
           <router-view></router-view>
         </div>
       </template>
       <template v-if="isError">
         <p>You are not logged in, please <router-link to="/login">log in</router-link> to your account</p>
       </template>
     </template>
     <template v-else>Loading...</template>
  </div>
</template>

<script>
import AdminMenu from './AdminMenu'
import {mapActions, mapGetters} from "vuex";

export default {
  components: {
    AdminMenu
  },
  computed: {
    ...mapGetters(['user']),
  },
  methods: {
    ...mapActions(['fetchData']),
  },
  data() {
    return {
      loading: true,
      isError: false,
    }
  },
  async created() {
    const result = await this.fetchData();

    if (!result.success) {
      this.isError = true;
    }

    this.loading = false;
  },
}
</script>